import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';

import { RestaurantsToolbar, RestaurantsTable } from './components';

import CircularProgress from '@mui/material/CircularProgress';
import { Alert } from '@mui/material';

import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchRestaurantsSuccess } from '../../store/actions/restaurant';

// import { authAdminAndGroupAdminMiddleWare } from 'util/authAdmin'
import { updateRestaurantkeyword } from 'store/actions/restaurant';

import { useQuery } from '@tanstack/react-query';
import { getRestaurants } from 'apis/restaurantAPIs';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5)
    }
  },
  content: {
    marginTop: theme.spacing(2)
  },
  uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	}
}));


const RestaurantList = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const updateFilter = (key) => dispatch(updateRestaurantkeyword(key));
  const user = useSelector((state) => state.account.user);
  
  // React Query hook for fetching restaurants
  const {
    data: restaurants = [],
    isLoading,
    isError,
    error,
    refetch,
    isFetching
  } = useQuery({
    queryKey: ['restaurants'],
    queryFn: async () => {
      try {
        return await getRestaurants();
      } catch (err) {
        console.error('getRestaurants error:', err);
        throw err;
      }
    },
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes cache time
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

  // Update Redux store when restaurants data changes
  useEffect(() => {
    if (restaurants && restaurants.length > 0) {
      dispatch(fetchRestaurantsSuccess(restaurants));
      dispatch(updateRestaurantkeyword(''));
    }
  }, [restaurants, dispatch]);

  // Handle errors
  useEffect(() => {
    if (isError) {
      console.error('Error fetching restaurants:', {
        error,
        status: error?.response?.status,
        message: error?.response?.data?.message,
        fullError: error
      });
      if (error?.response?.status === 403) {
        history.push('/sign-in');
      }
    }
  }, [isError, error, history]);

  // Log loading state for debugging
  useEffect(() => {
    console.log('RestaurantList state:', { isLoading, isFetching, isError, hasData: restaurants.length > 0 });
  }, [isLoading, isFetching, isError, restaurants]);

  const [statusFilter, setStatusFilter] = useState('all');
  const [paymentFilter, setPaymentFilter] = useState('all');
  const [deliveryProviderFilter, setDeliveryProviderFilter] = useState('all');
  const [terminalFilter, setTerminalFilter] = useState('all');
  const [kdsFilter, setKdsFilter] = useState('all');

  if (isError) {
    return (
      <main className={classes.content}>
        <Alert severity="error">
          {error?.response?.data?.message || error?.message || 'Error in retrieving the data'}
          <br />
          <button onClick={() => refetch()} style={{ marginTop: '10px' }}>
            Retry
          </button>
        </Alert>
      </main>
    );
  }

  if (isLoading) {
    return (
      <main className={classes.content}>
        <CircularProgress size={150} className={classes.uiProgess} />
        <div style={{ textAlign: 'center', marginTop: '200px', color: '#666' }}>
          Loading restaurants...
        </div>
      </main>
    );
  }

  return (
    <div className={classes.root}>
      <RestaurantsToolbar
        statusFilter={statusFilter}
        onStatusFilterChange={setStatusFilter}
        paymentFilter={paymentFilter}
        onPaymentFilterChange={setPaymentFilter}
        deliveryProviderFilter={deliveryProviderFilter}
        onDeliveryProviderFilterChange={setDeliveryProviderFilter}
        terminalFilter={terminalFilter}
        onTerminalFilterChange={setTerminalFilter}
        kdsFilter={kdsFilter}
        onKdsFilterChange={setKdsFilter}
      />
      <div className={classes.content}>
        <RestaurantsTable
          restaurants={restaurants}
          statusFilter={statusFilter}
          paymentFilter={paymentFilter}
          deliveryProviderFilter={deliveryProviderFilter}
          terminalFilter={terminalFilter}
          kdsFilter={kdsFilter}
        />
      </div>
    </div>
  );
};

export default RestaurantList;
